// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.designed-button[data-v-19a0f6c1] {\n  background: var(--19a0f6c1-colorCode);\n  border-radius: 50%;\n  /*width: v-bind(width);*/\n  /*height: v-bind(height);*/\n  min-height: var(--19a0f6c1-width);\n  min-width: var(--19a0f6c1-width);\n}\n", ""]);
// Exports
module.exports = exports;
